/**
 * Centralised commercial / payment / recovery copy.
 *
 * Purpose: every upgrade-flow component imports its repeated strings from
 * here so pricing, CTAs, and payment-pending wording can be changed in one
 * place. This is intentionally NOT a full copy framework — only strings
 * that appear in multiple places or are tied to commercial messaging.
 *
 * Backend-provided contextual messages (auditResponse.upgrade.message)
 * still take precedence in components that already use them; the constants
 * here are the static fallback / base copy.
 */

// ── Pricing ──────────────────────────────────────────────────────────
export const PRICE_AMOUNT = 29;
export const PRICE_LABEL = `£${PRICE_AMOUNT}`;
export const FULL_ANALYSIS_LABEL = 'Full Estate Analysis';
export const ONE_TIME_PAYMENT_LABEL = 'One-time payment. No subscription.';

// ── Upgrade CTAs ─────────────────────────────────────────────────────
export const PRIMARY_UPGRADE_CTA = 'See your exact inheritance tax';
export const SECONDARY_REPORT_CTA = 'Get full report';
/** WP1: trust property may be missing, so the full report is provisional — never "exact" or "confirm". */
export const PROVISIONAL_REPORT_CTA = 'See the provisional report and what is missing';
export const POST_CTA_SUPPORTING_LINE =
    'Understand your full position and what you can do next';

/** Convenience: CTA with price suffix, used by most upgrade buttons. */
export const PRIMARY_UPGRADE_CTA_WITH_PRICE = `${PRIMARY_UPGRADE_CTA} — ${PRICE_LABEL}`;

// ── Payment-pending recovery ─────────────────────────────────────────
export const PENDING_TITLE = 'Payment received — confirming your access';
export const PENDING_BODY =
    'This usually takes a few seconds. If access does not update shortly, you can refresh your status below.';
export const PENDING_REFRESH_LABEL = 'Refresh status';
export const PENDING_REFRESHING_LABEL = 'Refreshing…';
export const PENDING_FALLBACK =
    'If payment has completed but access still has not updated after a minute, please refresh the page or contact support.';

// ── Payment failure (single user-facing string) ──────────────────────
export const PAYMENT_FAILED_MESSAGE =
    "Payment didn't go through — please try again.";

// ── Support contact placeholder ──────────────────────────────────────
// Replace this single constant when a real support address is decided.
export const SUPPORT_CONTACT_LABEL = 'contact support';
